import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from 'services/authService';

// Mock user for UI testing
const mockUser: User = {
  id: 'mock-user-1',
  name: 'Test User',
  email: 'test@example.com',
  role: 'admin',
  status: 'active'
};

interface AuthState {
  user: User | null;
  token: string | null;
  setUser: (user: User, token: string) => void;
  logout: () => void;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      setUser: (user, token) => set({ user, token }),
      logout: () => set({ user: null, token: null }),
    }),
    {
      name: 'auth-storage',
    }
  )
);

export default useAuthStore;